import { render, staticRenderFns } from "./CreateNotificationRow.vue?vue&type=template&id=17e3ff5c&scoped=true"
import script from "./CreateNotificationRow.vue?vue&type=script&lang=js"
export * from "./CreateNotificationRow.vue?vue&type=script&lang=js"
import style0 from "./CreateNotificationRow.vue?vue&type=style&index=0&id=17e3ff5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e3ff5c",
  null
  
)

export default component.exports